var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomebasedIcon = function SvgHomebasedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "96px",
    viewBox: "0 0 97 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "homebasedGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A5ED",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3776AB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "homebased-path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.597, 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#homebasedGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "homebased-mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#homebased-path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5833334,11.6666666 C34.5833334,9.36548016 32.7178532,7.49999994 30.4166666,7.49999994 L29.375,7.49999994 L29.375,6.48763014 C29.375,5.92708326 28.9440105,5.44596347 28.3834636,5.41796868 C28.0988436,5.40425545 27.821031,5.50773794 27.6147405,5.70431056 C27.4084499,5.90088318 27.2916927,6.17338312 27.2916667,6.45833327 L27.2916667,7.49999994 L12.7083333,7.49999994 L12.7083333,6.48763014 C12.7083333,5.92708326 12.2773437,5.44596347 11.7167968,5.41796868 C11.4321769,5.40425545 11.1543643,5.50773794 10.9480737,5.70431056 C10.7417832,5.90088318 10.625026,6.17338312 10.625,6.45833327 L10.625,7.49999994 L9.58333328,7.49999994 C7.28214681,7.49999994 5.41666659,9.36548016 5.41666659,11.6666666 L5.41666659,12.4479166 C5.41666659,12.5917408 5.53325911,12.7083333 5.67708326,12.7083333 L34.3229167,12.7083333 C34.4667409,12.7083333 34.5833334,12.5917408 34.5833334,12.4479166 L34.5833334,11.6666666 Z M5.41666659,30.4166667 C5.41666659,32.7178532 7.28214681,34.5833334 9.58333328,34.5833334 L30.4166666,34.5833334 C32.7178532,34.5833334 34.5833334,32.7178532 34.5833334,30.4166667 L34.5833334,15.0520833 C34.5833334,14.9082592 34.4667409,14.7916666 34.3229167,14.7916666 L5.67708326,14.7916666 C5.53325911,14.7916666 5.41666659,14.9082592 5.41666659,15.0520833 L5.41666659,30.4166667 Z",
    id: "Combined-Shape",
    fill: "#E2F2FF",
    mask: "url(#homebased-mask-3)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomebasedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homebased-icon.97f6606c.svg";
export { ForwardRef as ReactComponent };